import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AnnouncementSection from './components/AnnouncementSection';
import DownloadSection from './components/DownloadSection';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import NewsSection from './components/NewsSection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '91在线视频',
            url: 'https://www.91zaixianshipin.com',
            description: '91在线视频官方访问入口，提供网站最新地址、移动端APP下载与在线视频内容承接。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.91zaixianshipin.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91在线视频 - 官网入口与APP下载',
            description: '91在线视频官方访问入口，提供网站最新地址、移动端APP下载与在线视频内容承接。',
            url: 'https://www.91zaixianshipin.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '91在线视频',
              url: 'https://www.91zaixianshipin.com',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AnnouncementSection />
        <DownloadSection />
        <CategorySection />
        <HotSection />
        <NewsSection />
      </main>
      <Footer />
    </>
  );
}